import React, { Component } from 'react'
import {
    Button, Container
} from 'reactstrap'
import Productos from '../../productos'
import EditarProducto from './editarProducto'
import Producto from '../../utilitarios/producto'
import ProductosCategoria from '../productosCategoria'
import './AdminProductos.css'
const Prod = new Producto()

export default class AdminProductos extends Component {
    constructor(props) {
        super(props)

        this.state = {
            producto: null,
            productos: [],
            verCategorias: false,
            update: false
        }
        this.productoNuevo = this.productoNuevo.bind(this)
        this.productoEditar = this.productoEditar.bind(this)
        this.productoEliminar = this.productoEliminar.bind(this)
        this.productoNull = this.productoNull.bind(this)
        this.verCategorias = this.verCategorias.bind(this)
        this.verProductos = this.verProductos.bind(this)
    }


    productoNuevo() {
        this.setState({
            producto: new Producto
        })
    }

    productoEditar(producto) {
        this.setState({
            producto
        })
    }

    productoEliminar(producto) {
        const _this = this
        const { id } = producto
        let eliminar = window.confirm(`¿Desea eliminar éste producto? \n ${producto.Descripcion}`)
        if (eliminar) {
            Prod.eliminar(id).then(() => {
                //let productos = _this.state.productos.filter(ele => ele.id !== id)
                _this.setState({
                    update: true
                }) 
                _this.setState({
                    update: false
                }) 
            })
            .catch(err => console.error(err))
        }
    }

    productoNull() {
        this.setState({
            producto: null
        })
    }

    verCategorias() {
        this.setState({ verCategorias: true })
    }

    verProductos() {
        this.setState({ verCategorias: false })
    }

    componentWillMount() {
        // let _this = this
        // usuario.getUserLogged().then(u => console.log('usuario',u))
        // database.collection('productos')
        //     .onSnapshot(querySnapshot => {
        //         _this.setState({
        //             productos: querySnapshot.docs
        //         })
        //     })
    }


    render() {
        return (
            <Container className="AdminProductos">
                {
                    this.state.verCategorias ?
                        <ProductosCategoria atras={this.verProductos} />
                        :
                        this.state.producto ?
                            <EditarProducto
                                producto={this.state.producto}
                                atras={this.productoNull}
                            />
                            :
                            <div>
                                <h2>Administracion de productos</h2>
                                <Button className="btnNuevoProducto" onClick={this.productoNuevo} color="dark" >Nuevo producto</Button>{' '}
                                <Button className="btnNuevoProducto" onClick={this.verCategorias} color="dark" >Categorías</Button>
                                <Productos
                                    update={this.state.update}
                                    productos={this.state.productos}
                                    productoEditar={this.productoEditar}
                                    productoEliminar={this.productoEliminar}
                                    btnInfoDisabled={true}
                                    adm={true}
                                />
                            </div>
                }
            </Container>

        )
    }

}